<template>
  <div class="filter-line">
    <div class="filter-line__field">
      <up-input
        :propValue="value"
        :placeholder="$t('shared.filters.search_placeholder')"
        @onInput="(e) => value = e"
      />
      <button
        v-if="value"
        type="button"
        class="filter-line__clear"
        :aria-label="$t('shared.filters.search_clear')"
        @click="clear"
      >
        <i class="exu-x-close" />
      </button>
    </div>
    <button
      type="button"
      @click="clickButton"
      :class="{ 'is-active': !!value }"
      class="up-btn-line-icon"
    >
      <i class="exu-search-1" />
    </button>
  </div>
</template>
<script>
export default {
  name: 'upInputFilter',
  props: {
    // начальный запрос: нужен, когда список возвращается к прежнему состоянию
    startValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localValue: this.startValue,
    };
  },
  watch: {
    // запрос могли сменить снаружи — например, из панели фильтров
    startValue(value) {
      this.localValue = value;
    },
  },
  computed: {
    value: {
      get() {
        return this.localValue;
      },
      set(data) {
        this.localValue = data;
        // this.$emit('onInput', data);
      },
    },
  },
  methods: {
    clickButton() {
      this.$emit('onSearch', this.localValue);
    },
    // крестик не просто чистит поле — он сразу возвращает полный список,
    // иначе пользователю пришлось бы нажимать лупу по пустому полю
    clear() {
      this.localValue = null;
      this.$emit('onSearch', null);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/style/variables.scss';

// Строка каталога — воронка, поле и лупа — читается как одна группа:
// элементы стоят с небольшим зазором, скруглены только наружные края,
// внутренние углы прямые. Радиус и толщина рамки как у кнопок панели
// фильтров. Воронки может не быть (сервер не отдал конфиг фильтров) —
// тогда левый край группы достаётся полю.
$line-border: 2px;
$line-radius: 18px;
$line-gap: 8px;
// со скруглённой стороны содержимое кнопки сдвигаем к центру,
// иначе иконка липнет к дуге
$line-edge-pad: 4px;

.filter-line {
  display: flex;
  align-items: center;
  gap: $line-gap;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 0;
  background: $color-base-secondary;

  input.up-form-control {
    flex: 1 1 100%;
  }

  // Поле с крестиком внутри: крестик лежит поверх правого края поля,
  // как у поиска по карте, и появляется только при непустом тексте.
  &__field {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1 1 100%;
    min-width: 0;

    input.up-form-control {
      padding-right: 44px;
      border: $line-border solid $color-primary;
      border-radius: 0;
    }
  }

  &__clear {
    position: absolute;
    right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 20px;
    color: $color-text-secondary;
    cursor: pointer;
  }

  // лупа — всегда последняя в группе
  & > .up-btn-line-icon {
    padding-right: $line-edge-pad;
    border-top-right-radius: $line-radius;
    border-bottom-right-radius: $line-radius;
  }

  // поле без воронки перед ним — начало группы
  &:first-child &__field input.up-form-control {
    padding-left: 12px + $line-edge-pad;
    border-top-left-radius: $line-radius;
    border-bottom-left-radius: $line-radius;
  }
}
// Обёртка строки на экране каталога: воронка стоит в ней перед полем.
.catalog-search-line {
  display: flex;
  align-items: center;
  gap: $line-gap;

  .filter-line {
    background: transparent;
  }

  & > .up-btn-line-icon {
    padding-left: $line-edge-pad;
    border-top-left-radius: $line-radius;
    border-bottom-left-radius: $line-radius;
  }
}
// Квадратная кнопка-иконка в строке поиска: лупа и воронка каталога должны
// выглядеть и нажиматься одинаково, поэтому стиль один на обе.
.up-btn-line-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 52px;
  width: 52px;
  height: 48px;
  padding: 0;
  background: $color-base;
  border: $line-border solid $color-primary;
  border-radius: 0;
  color: $color-primary;

  & > i {
    font-size: 1.25rem;
  }

  &:active {
    background-color: $color-accent;
    border-color: $color-accent;
    color: $color-base;
  }

  // в поле есть текст — лупа обведена акцентом
  &.is-active {
    border-color: $color-accent;
    color: $color-accent;
  }

  // фильтр применён — воронка залита акцентом
  &.is-applied {
    background-color: $color-accent;
    border-color: $color-accent;
    color: $color-base;
  }
}
</style>
